<template>
  <CampaignKpiBox
    :showCloseButton="isEditing"
    @closeKpiBox="$emit('removeKpi', kpi.key)"
  >
    <template slot="label" v-if="kpi">{{ kpi.label }}</template>
    <template slot="content">
      <span v-if="!kpi" class="no-kpis-message"><loading-icon /></span>
      <span v-else-if="!kpi || !kpi.results.length" class="no-kpis-message">no data available</span>
      <div v-else class="kpi-details">
        <div class="progress-bar-container" v-for="kpiData in kpi.results">
          <div class="progress-bar-info">
            <span class="truncate">{{ kpiData.name }}</span>
            <span>{{ kpiData.percent }}%</span>
          </div>
          <progress-bar :progress="kpiData.percent/100" />
        </div>
      </div>
    </template>
  </CampaignKpiBox>
</template>

<script>
import {ProgressBar, LoadingIcon} from "@springbig/sb-components";
import CampaignKpiBox from "./CampaignKpiBox";

export default {
  name: 'campaign-kpi-box-info',
  components: {
    ProgressBar,
    CampaignKpiBox,
    LoadingIcon
  },
  props: {
    isEditing: false,
    kpi: null,
  },
}
</script>

<style scoped>

  .kpi-details {
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: space-evenly;
    flex: 1;
  }

  .progress-bar-info{
    display: flex;
    justify-content: space-between;
    font-size:0.8em;
    line-height: 1em;
  }

</style>
